/*
 * Menú del teléfono armado con los MISMOS bloques del header que pintan la barra de
 * escritorio. Un solo lugar que editar: lo que Tony agrega, renombra, reordena u oculta en
 * el personalizador aparece en los dos lados.
 *
 * Por qué aquí y no en Liquid (2026-07-24, verificado in-vivo contra la tienda real):
 *   1. `content_for 'blocks'` solo admite UNA llamada por sección — la segunda aborta el
 *      push con "Duplicate entries for content_for 'blocks'".
 *   2. Los theme blocks no se pueden leer desde Liquid: `block.type` devuelve "@theme",
 *      `block.settings` viene vacío y los hijos no se ven.
 * Con esas dos, copiar el árbol ya pintado es la única vía que conserva una sola fuente.
 *
 * Traduce el markup del mega-menú al markup del cajón de Dawn (mismas clases, mismo
 * comportamiento) y engancha los manejadores del propio <header-drawer>, para no duplicar
 * la lógica de apertura, foco y cierre.
 */
(function () {
  'use strict';

  var NAV = '.header__inline-menu';
  var LISTA = '[data-kratus-drawer-menu]';

  function icono(nombre) {
    var plantilla = document.getElementById('kratus-drawer-icons');
    if (!plantilla || !plantilla.content) return document.createElement('span');
    var fuente = plantilla.content.querySelector('[data-icon="' + nombre + '"]');
    return fuente ? fuente.cloneNode(true) : document.createElement('span');
  }

  function botonVolver(titulo) {
    var boton = document.createElement('button');
    boton.className = 'menu-drawer__close-button link link--text focus-inset';
    boton.setAttribute('aria-expanded', 'true');
    boton.appendChild(icono('arrow'));
    boton.appendChild(document.createTextNode(titulo));
    return boton;
  }

  function listaVacia() {
    var ul = document.createElement('ul');
    ul.className = 'menu-drawer__menu list-menu';
    ul.setAttribute('role', 'list');
    ul.tabIndex = -1;
    return ul;
  }

  // Un enlace del mega pasa a ser una fila del cajón, conservando su estado apagado.
  function filaDeEnlace(enlace) {
    var li = document.createElement('li');
    var copia = enlace.cloneNode(true);
    var apagado = enlace.classList.contains('kratus-mlink--soon');
    copia.removeAttribute('id');
    copia.className =
      'menu-drawer__menu-item link link--text list-menu__item focus-inset' +
      (apagado ? ' menu-drawer__menu-item--soon' : '');
    li.appendChild(copia);
    return li;
  }

  function tarjetaDeCajon(tarjeta) {
    var copia = tarjeta.cloneNode(true);
    copia.classList.add('menu-drawer__tile');
    if (tarjeta.classList.contains('mega-menu__tile--soon')) {
      copia.classList.add('menu-drawer__tile--soon');
    }
    var marco = copia.querySelector('.mega-menu__tile-media');
    if (marco) marco.classList.add('menu-drawer__tile-media');
    return copia;
  }

  function entradaDesplegable(item, indice) {
    var resumenOrigen = item.querySelector('summary.header__menu-item');
    if (!resumenOrigen) return null;

    var titulo = (resumenOrigen.textContent || '').trim();
    var panel = item.querySelector('.mega-menu__panel');

    var details = document.createElement('details');
    details.id = 'Details-menu-drawer-menu-item-' + (indice + 1);

    var resumen = document.createElement('summary');
    resumen.className = 'menu-drawer__menu-item list-menu__item link link--text focus-inset';
    resumen.appendChild(document.createTextNode(titulo));
    resumen.appendChild(icono('arrow'));
    resumen.appendChild(icono('caret'));
    details.appendChild(resumen);

    var submenu = document.createElement('div');
    submenu.className = 'menu-drawer__submenu has-submenu gradient motion-reduce';
    submenu.tabIndex = -1;

    var interior = document.createElement('div');
    interior.className = 'menu-drawer__inner-submenu';
    interior.appendChild(botonVolver(titulo));

    var lista = listaVacia();

    if (panel) {
      // Columnas: con título se vuelven un segundo nivel; sin título, sus enlaces suben.
      Array.prototype.forEach.call(panel.querySelectorAll('.mega-menu__shop-col'), function (columna, i) {
        var enlaces = columna.querySelectorAll('.kratus-mlink');
        if (!enlaces.length) return;

        var encabezado = columna.querySelector('.mega-menu__shop-col-heading');
        var tituloColumna = encabezado ? (encabezado.textContent || '').trim() : '';

        if (!tituloColumna) {
          Array.prototype.forEach.call(enlaces, function (enlace) {
            lista.appendChild(filaDeEnlace(enlace));
          });
          return;
        }

        var li = document.createElement('li');
        var subDetails = document.createElement('details');
        subDetails.id = 'Details-menu-drawer-' + (indice + 1) + '-' + (i + 1);

        var subResumen = document.createElement('summary');
        subResumen.className = 'menu-drawer__menu-item link link--text list-menu__item focus-inset';
        subResumen.appendChild(document.createTextNode(tituloColumna));
        subResumen.appendChild(icono('arrow'));
        subResumen.appendChild(icono('caret'));
        subDetails.appendChild(subResumen);

        var subPanel = document.createElement('div');
        subPanel.className = 'menu-drawer__submenu has-submenu gradient motion-reduce';
        subPanel.appendChild(botonVolver(tituloColumna));

        var subLista = listaVacia();
        Array.prototype.forEach.call(enlaces, function (enlace) {
          subLista.appendChild(filaDeEnlace(enlace));
        });
        subPanel.appendChild(subLista);
        subDetails.appendChild(subPanel);
        li.appendChild(subDetails);
        lista.appendChild(li);
      });

      // Enlaces sueltos del panel (los grandes de "Comunidad"), sin columna de por medio.
      Array.prototype.forEach.call(panel.children, function (envoltorio) {
        var enlace = envoltorio.querySelector(':scope > .kratus-mlink');
        if (enlace) lista.appendChild(filaDeEnlace(enlace));
      });
    }

    interior.appendChild(lista);

    var tarjetas = panel ? panel.querySelectorAll('.mega-menu__tile') : [];
    if (tarjetas.length) {
      var rejilla = document.createElement('div');
      rejilla.className = 'menu-drawer__tiles';
      Array.prototype.forEach.call(tarjetas, function (tarjeta) {
        rejilla.appendChild(tarjetaDeCajon(tarjeta));
      });
      interior.appendChild(rejilla);
    }

    submenu.appendChild(interior);
    details.appendChild(submenu);
    return details;
  }

  function construir() {
    var nav = document.querySelector(NAV);
    var lista = document.querySelector(LISTA);
    if (!nav || !lista) return;

    var fragmento = document.createDocumentFragment();

    Array.prototype.forEach.call(nav.querySelectorAll('.kratus-nav__item'), function (item, indice) {
      var li = document.createElement('li');
      var enlacePlano = item.querySelector('a.header__menu-item');

      if (enlacePlano) {
        var a = document.createElement('a');
        a.href = enlacePlano.getAttribute('href') || '#';
        a.className = 'menu-drawer__menu-item list-menu__item link link--text focus-inset';
        a.textContent = (enlacePlano.textContent || '').trim();
        li.appendChild(a);
      } else {
        var desplegable = entradaDesplegable(item, indice);
        if (!desplegable) return;
        li.appendChild(desplegable);
      }

      fragmento.appendChild(li);
    });

    lista.textContent = '';
    lista.appendChild(fragmento);
    enganchar(lista);
  }

  // Reusa los manejadores del propio <header-drawer> en vez de reimplementarlos. Si el
  // elemento todavía no se ha inicializado, su propio bindEvents() recogerá este markup.
  function enganchar(lista) {
    var cajon = document.querySelector('header-drawer');
    if (!cajon || typeof cajon.onSummaryClick !== 'function') return;

    Array.prototype.forEach.call(lista.querySelectorAll('summary'), function (resumen) {
      resumen.addEventListener('click', cajon.onSummaryClick.bind(cajon));
    });
    Array.prototype.forEach.call(lista.querySelectorAll('button'), function (boton) {
      boton.addEventListener('click', cajon.onCloseButtonClick.bind(cajon));
    });
  }

  var pendiente = null;
  function reconstruir() {
    clearTimeout(pendiente);
    pendiente = setTimeout(construir, 50);
  }

  construir();

  // El personalizador vuelve a pintar el header cada vez que Tony toca un bloque.
  document.addEventListener('shopify:section:load', reconstruir);
  document.addEventListener('shopify:block:select', reconstruir);

  var nav = document.querySelector(NAV);
  if (nav && window.MutationObserver) {
    new MutationObserver(reconstruir).observe(nav, { childList: true, subtree: true });
  }
})();
